/**
 * 评估项计分方式(spec-non-academic-grade-entry F-0,迁移 051)。
 * 百分制是旧行为;等级制 / 合格制的分数存老师写的原始等级,算学期成绩时按评价标准里的
 * levels 折成百分比。默认表与后端 services/gpa.py DEFAULT_LEVELS 一致 —— 真正算分的是后端,
 * 这里只用来显示和编辑。
 */
export type ScaleType = "percent" | "grade" | "pass_fail";
export interface ScaleLevel { label: string; percent: number }
export const SCALE_TYPES: ScaleType[] = ["percent", "grade", "pass_fail"];

export const DEFAULT_LEVELS: Record<Exclude<ScaleType, "percent">, ScaleLevel[]> = {
  grade: [{ label: "优秀", percent: 95 }, { label: "良好", percent: 85 }, { label: "合格", percent: 70 }, { label: "不合格", percent: 50 }],
  pass_fail: [{ label: "合格", percent: 85 }, { label: "不合格", percent: 50 }],
};

export function itemScale(item: { scale?: string } | null | undefined): ScaleType {
  const s = item?.scale;
  return s === "grade" || s === "pass_fail" ? s : "percent";
}

export function itemLevels(item: { scale?: string; levels?: ScaleLevel[] } | null | undefined): ScaleLevel[] {
  const sc = itemScale(item);
  if (sc === "percent") return [];
  const lv = (item?.levels ?? []).filter((x) => x && x.label);
  return lv.length ? lv : DEFAULT_LEVELS[sc].map((x) => ({ ...x }));
}

export function levelPercent(item: { scale?: string; levels?: ScaleLevel[] } | null | undefined, label: string | null | undefined): number | null {
  if (!label) return null;
  const hit = itemLevels(item).find((x) => x.label.trim() === label.trim());
  return hit ? hit.percent : null;
}
